// emailService.js
import  apiClient  from '../../../../services/apiClient';
import { getRequestsList } from '../../../statistic_public/actions'; 

export const emailService = {
  /**
   * Получить список заявок по текущему email или номеру свидетельства о рождении.
   * Головна рядок пошуку (search) на бекенді шукає лише по свідоцтву,
   * тому email передаємо окремо через columnFilters.email.
   *
   * ВАЖЛИВО: columnFilters.email на бекенді шукає ТІЛЬКИ по
   * responsiblePerson.contacts.email — саме те поле, яке реально змінює
   * updateApplicationsEmail нижче (updateRequestEmail в моделі). Якщо десь
   * знадобиться пошук одразу по всіх email-полях заявки (контакти +
   * KyivID-профіль), використовуйте інший ключ фільтра — columnFilters.emailAny.
   * @param {string} query
   */
  async getApplicationsByEmail(query) {
    const isEmail = query.includes('@');

    const result = await getRequestsList({
      ...(isEmail
        ? { columnFilters: { email: query } }
        : { search: query }),
      pageSize: 100,
      fieldsCons:{
        id: "_id",
        date: "createdAt", 
        childName: "child.firstName",
        number: "registrationNumber", 
        birthCertificate: "child.birthCertificate.number",
        phone: "responsiblePerson.contacts.phone",
        email: "responsiblePerson.contacts.email" 
      }
    });

    return result;
  },

  /**
   * Обновить email во всех заявках
   * @param {string} currentEmail 
   * @param {string} newEmail 
   */
  async updateApplicationsEmail(currentEmail, newEmail) {
    
    return apiClient.post('requests/update_kyivid_email', {
      oldEmail: currentEmail,
      newEmail
    });
  }
};